import { createFileRoute } from '@tanstack/react-router';

// GuidedSetupAdmin parses /guidedSetups/:slug/build/:nodeId from the pathname
// itself; this splat only keeps those URLs from falling through to the
// authenticated catch-all redirect.
export const Route = createFileRoute('/_authenticated/guidedSetups/$')({});
